import { render } from "./AclRulesTab.vue?vue&type=template&id=ec50b5a8&scoped=true"
import script from "./AclRulesTab.vue?vue&type=script&lang=js"
export * from "./AclRulesTab.vue?vue&type=script&lang=js"

import "./AclRulesTab.vue?vue&type=style&index=0&id=ec50b5a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec50b5a8"]])

export default __exports__